module.exports = __webpack_public_path__ + "img/aupply_04.9ed7c681.jpg";